import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { BasicSnackbarComponent } from "../component/snackbars/basic-snackbar/basic-snackbar.component";

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  showSnackbar(message: string, success: boolean, duration: number = 3000): void {
    const config: MatSnackBarConfig = {
      data: {
        message: message,
        success: success
      },
      duration: duration,
      panelClass: [success ? 'basic-snackbar-success' : 'basic-snackbar-fail']
    };
    this.snackBar.openFromComponent(BasicSnackbarComponent, config);
  }


  /**
   * Displays a snackbar notification with a custom message, type and duration.
   *
   * Wraps Angular Material's `MatSnackBar` service to show a `BasicSnackbarComponent`
   * with consistent configuration. The snackbar appearance and behavior are
   * determined by the provided `type` and `duration`.
   *
   * @param message Text to display inside the snackbar
   * @param type Type of the snackbar ('success' | 'fail' | 'warning'). Used for styling via 'panelClass'
   * @param duration How long the snackbar should stay visible in milliseconds. Defaults to 3000ms
   */
  public showSnackbarByType(message: string, type: 'success' | 'fail' | 'warning', duration: number = 3000): void {
    const config: MatSnackBarConfig = {
      data: {
        message,
        type
      },
      duration,
      panelClass: [`basic-snackbar-${type}`]
    };
    this.snackBar.openFromComponent(BasicSnackbarComponent, config);
  }
}
